
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.3.1
 * Query Engine version: acc0b9dd43eb689cbd20c9470515d719db10d0b0
 */
Prisma.prismaVersion = {
  client: "6.3.1",
  engine: "acc0b9dd43eb689cbd20c9470515d719db10d0b0"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  password: 'password',
  username: 'username',
  avatar: 'avatar',
  role: 'role',
  level: 'level',
  source: 'source',
  publicProfile: 'publicProfile',
  active: 'active',
  accessLevel: 'accessLevel',
  createdAt: 'createdAt',
  googleId: 'googleId',
  facebookId: 'facebookId',
  microsoftId: 'microsoftId',
  customerId: 'customerId',
  teamId: 'teamId'
};

exports.Prisma.AttributionScalarFieldEnum = {
  id: 'id',
  utmSource: 'utmSource',
  utmMedium: 'utmMedium',
  utmCampaign: 'utmCampaign',
  clickId: 'clickId',
  createdAt: 'createdAt',
  userId: 'userId'
};

exports.Prisma.BookmarkScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  packId: 'packId'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  expiresAt: 'expiresAt',
  userId: 'userId'
};

exports.Prisma.PackScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  image: 'image',
  color: 'color',
  private: 'private',
  original: 'original',
  language: 'language',
  prompt: 'prompt',
  rating: 'rating',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  category: 'category',
  collectionId: 'collectionId',
  sourceId: 'sourceId'
};

exports.Prisma.CollectionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  userId: 'userId'
};

exports.Prisma.PlaylistPackScalarFieldEnum = {
  playlistId: 'playlistId',
  packId: 'packId',
  order: 'order',
  createdAt: 'createdAt'
};

exports.Prisma.PlaylistScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  order: 'order',
  published: 'published',
  createdAt: 'createdAt'
};

exports.Prisma.FeaturedPackScalarFieldEnum = {
  id: 'id',
  packId: 'packId',
  order: 'order',
  createdAt: 'createdAt'
};

exports.Prisma.PackWordScalarFieldEnum = {
  packId: 'packId',
  wordId: 'wordId',
  createdAt: 'createdAt'
};

exports.Prisma.WordScalarFieldEnum = {
  id: 'id',
  solution: 'solution',
  difficulty: 'difficulty',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
};

exports.Prisma.AlternateScalarFieldEnum = {
  id: 'id',
  text: 'text',
  createdAt: 'createdAt',
  wordId: 'wordId'
};

exports.Prisma.DefinitionScalarFieldEnum = {
  id: 'id',
  text: 'text',
  partOfSpeech: 'partOfSpeech',
  attribution: 'attribution',
  source: 'source',
  image: 'image',
  query: 'query',
  sbs: 'sbs',
  audio: 'audio',
  createdAt: 'createdAt',
  wordId: 'wordId'
};

exports.Prisma.GameScalarFieldEnum = {
  id: 'id',
  time: 'time',
  fullName: 'fullName',
  createdAt: 'createdAt',
  userId: 'userId',
  packId: 'packId',
  assignmentId: 'assignmentId'
};

exports.Prisma.AnswerScalarFieldEnum = {
  id: 'id',
  correct: 'correct',
  createdAt: 'createdAt',
  wordId: 'wordId',
  gameId: 'gameId'
};

exports.Prisma.AssignmentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  notes: 'notes',
  timeLimit: 'timeLimit',
  expiresAt: 'expiresAt',
  settings: 'settings',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  packId: 'packId'
};

exports.Prisma.InvitationScalarFieldEnum = {
  id: 'id',
  email: 'email',
  createdAt: 'createdAt',
  userId: 'userId'
};

exports.Prisma.OldPackScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  packId: 'packId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.Category = exports.$Enums.Category = {
  LANGUAGE_ARTS: 'LANGUAGE_ARTS',
  SCIENCE: 'SCIENCE',
  HISTORY: 'HISTORY',
  GEOGRAPHY: 'GEOGRAPHY',
  ART_AND_MUSIC: 'ART_AND_MUSIC',
  SOCIAL_STUDIES: 'SOCIAL_STUDIES',
  BUSINESS: 'BUSINESS',
  TECHNOLOGY: 'TECHNOLOGY',
  TEST_PREP: 'TEST_PREP',
  TRIVIA: 'TRIVIA',
  MATH: 'MATH'
};

exports.Difficulty = exports.$Enums.Difficulty = {
  easy: 'easy',
  medium: 'medium',
  hard: 'hard',
  junior: 'junior',
  basic: 'basic',
  intermediate: 'intermediate',
  advanced: 'advanced',
  expert: 'expert',
  legend: 'legend'
};

exports.Setting = exports.$Enums.Setting = {
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  HIDE_FIRST_LETTER: 'HIDE_FIRST_LETTER',
  HIDE_PROGRESS_BAR: 'HIDE_PROGRESS_BAR',
  STRICT_CAPITALIZATION: 'STRICT_CAPITALIZATION',
  STRICT_PUNCTUATION: 'STRICT_PUNCTUATION',
  STRICT_ACCENTS: 'STRICT_ACCENTS',
  DISABLE_TIME_REWARDS: 'DISABLE_TIME_REWARDS',
  DISABLE_HINT: 'DISABLE_HINT',
  ENABLE_PACK_PROGRESS_BAR: 'ENABLE_PACK_PROGRESS_BAR',
  IMAGE_MATCH: 'IMAGE_MATCH'
};

exports.Prisma.ModelName = {
  User: 'User',
  Attribution: 'Attribution',
  Bookmark: 'Bookmark',
  Session: 'Session',
  Pack: 'Pack',
  Collection: 'Collection',
  PlaylistPack: 'PlaylistPack',
  Playlist: 'Playlist',
  FeaturedPack: 'FeaturedPack',
  PackWord: 'PackWord',
  Word: 'Word',
  Alternate: 'Alternate',
  Definition: 'Definition',
  Game: 'Game',
  Answer: 'Answer',
  Assignment: 'Assignment',
  Invitation: 'Invitation',
  OldPack: 'OldPack'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
